import CityPageMosquiteras from "../components/CityPageMosquiteras";

export default function Page() {
  return (
    <CityPageMosquiteras
      name="Torremolinos"
      slug="torremolinos"
      cp="29620"
      poblacion={71270}
      zonaGeo="Costa del Sol Occidental"
      lat={36.6203}
      lng={-4.4998}
      zonas={["La Carihuela", "Playamar", "Centro", "Montemar", "Bajondillo"]}
      landmarks={["Playa La Carihuela", "Plaza Costa del Sol"]}
      municipiosLimitrofes={["Málaga", "Benalmádena", "Alhaurín de la Torre"]}
      festivalLocal="Feria de San Miguel (septiembre)"
      contextoTipologico="Apartamentos costeros con ventanales hacia la playa, restaurantes y chiringuitos La Carihuela con altísima necesidad de protección anti-insectos, 121 nacionalidades residentes."
      isCoreZone={true}
    />
  );
}